module.exports = __webpack_public_path__ + "img/15.535917c2.webp";